import { Routes } from '@angular/router';
import { ForgotPasswordComponent, RegisterComponent, SsoComponent, ProfileComponent, EmployeeComponent } from 'wire-frame';
import { AdminShellComponent } from './component/admin/admin-shell/admin-shell.component';
import { AdminLogoutComponent } from './component/sso/admin-logout/admin-logout.component';
import { DoctorLoginComponent } from './component/auth/doctor-login/doctor-login.component';
import { PrescriptionsComponent } from './component/admin/prescriptions/prescriptions.component';
import { MedicineComponent } from './component/admin/medicine/medicine.component';
import { PatientRegistrationComponent } from './component/admin/patient-registration/patient-registration.component';
import { PreConsultationComponent  } from './component/admin/pre-consultation/pre-consultation.component';
import { PurchaseOrderComponent } from './component/admin/purchaseorder/purchaseorder.component';
import { SupplierComponent } from './component/admin/supplier/supplier.component';
import { AdminInventoryComponent } from './component/admin/admin-inventory/admin-inventory.component';
import { AppointmentComponent } from './component/admin/appointment/appointment.component';
import { AppointmentListComponent } from './component/admin/appointment-list/appointment-list.component';
import { QueueBoardComponent } from './component/admin/queue-board/queue-board.component';
import { CalendarComponent } from './component/admin/calendar/calendar.component';
import { ClinicSupplyComponent } from './component/admin/clinicsupply/clinicsupply.component';
import { PharmacyComponent } from './component/admin/pharmacy/pharmacy.component';
import { VoicetestComponent } from './component/admin/voicetest/voicetest.component';
import { AppointmentSuccessComponent } from './component/admin/appointment-success/appointment-success.component';
import { CardsComponent } from './component/admin/cards/cards.component';
import { authGuard } from './auth.guard';
import { DashboardComponent } from './component/admin/dashboard/dashboard.component';
import { CertificatesComponent } from './component/admin/certificates/certificates.component';
import { ClinicManagementComponent } from './component/admin/clinic-management/clinic-management.component';
// import { MedicineFinderComponent } from './component/admin/medicine-finder/medicine-finder.component';
import { AnalyticsCollectionsComponent } from './component/admin/analytics-collections/analytics-collections.component';
import { PatientSelfRegistrationComponent } from './component/public/patient-self-registration/patient-self-registration.component';
import { PendingRegistrationsComponent } from './component/admin/pending-registrations/pending-registrations.component';

export const routes: Routes = [
  {
    path: 'register',
    component: PatientSelfRegistrationComponent,
    title: 'Patient Registration',
  },
  {
    path: 'sso/admlogout',
    component: AdminLogoutComponent,
    title: 'Logout',
  },
  {
    path: 'sso/admlogin',
    component: DoctorLoginComponent,
    title: 'Login',
  },
  {
    path: 'sso',
    component: SsoComponent,
    children: [
      // {
      //   path: 'admlogin',
      //   component: LoginComponent,
      //   title: 'Login',
      // },
      // {
      //   path: 'agentlogin',
      //   component: AgentLoginComponent,
      //   title: 'Agent Login',
      // },
      // {
      //   path: 'customerlogin',
      //   component: CustomerLoginComponent,
      //   title: 'Customer Login',
      // },
      // {
      //   path: 'admregister',
      //   component: RegisterComponent,
      //   title: 'Register User',
      // },
      // {
      //   path: 'applied-passport',
      //   component: AppliedPassportComponent,
      //   title: 'Applied Passport',
      // },
      
      // {
      //   path: 'customer-register',
      //   component: CustomerRegisterComponent,
      //   title: 'Customer Register',
      // },
      // {
      //   path: 'agent-register',
      //   component: AgentRegisterComponent,
      //   title: 'Agent Register',
      // },
      {
        path: 'register',
        component: RegisterComponent,
        title: 'Register User',
      },
      {
        path: 'admforgotpassword',
        component: ForgotPasswordComponent,
        title: 'Forgot Password',
      },
      { path: '', redirectTo: '/sso/admlogin', pathMatch: 'full' },
    ],
  },
  {
    path: 'admin',
    component: AdminShellComponent,
    canActivateChild: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, title: 'Dashboard' },
      { path: 'profile', component: ProfileComponent, title: 'Profiles' },
      { path: 'employee', component: EmployeeComponent, title: 'Profiles' },
      {
        path: 'prescriptions',
        component: PrescriptionsComponent,
        title: 'Prescriptions',
      },
      {
        path: 'medicine',
        component: MedicineComponent,
        title: 'medicine',
      },
      {
        path: 'patient-registration',
        component: PatientRegistrationComponent,
        title: 'Patient Registration',
      },
      {
        path: 'pending-registrations',
        component: PendingRegistrationsComponent,
        title: 'Self Registrations',
      },
      {
        path: 'cards',
        component: CardsComponent,
        title: 'Cards',
      },
      {
        path: 'pre-consultation',
        component: PreConsultationComponent,
        title: 'Pre Consultation',
      },
      {
        path: 'purchaseorder',
        component: PurchaseOrderComponent,
        title: 'Purchase Order',
      },
      {
        path: 'supplier',
        component: SupplierComponent,
        title: 'Supplier',
      },
      {
        path: 'admin-inventory',
        component: AdminInventoryComponent,
        title: 'Admin Inventory',
      },
      {
        path: 'appointment',
        component: AppointmentComponent,
        title: 'Appointment',
      },
      {
        path: 'appointment/success',
        component: AppointmentSuccessComponent,
        title: 'Appointment',
      },
      {
        path: 'appointment-list',
        component: AppointmentListComponent,
        title: 'Appointment List',
      },
      {
        path: 'queue-board',
        component: QueueBoardComponent,
        title: 'Queue Board',
      },
       {
        path: 'calendar',
        component: CalendarComponent,
        title: 'Calendar',
      },
      {
        path: 'clinicsupply', 
        component: ClinicSupplyComponent,
        title: 'Clinic Supply' 
      },
      {
        path: 'pharmacy', 
        component: PharmacyComponent,
        title: 'Pharmacy' 
      },
      {
        path: 'voicetest', 
        component: VoicetestComponent,
        title: 'Voicetest' 
      },
      {
        path: 'clinic-management',
        component: ClinicManagementComponent,
        title: 'Clinic Management',
      },
      {
        path: 'certificates', 
        component: CertificatesComponent,
        title: 'Certificates' 
      },
      {
        path: 'analytics-collections', 
        component: AnalyticsCollectionsComponent,
        title: 'Analytics Collections' 
      },
      { path: '', redirectTo: '/admin/dashboard', pathMatch: 'full' },
    ],
  },
  { path: '', redirectTo: '/sso/admlogin', pathMatch: 'full' },
  // { path: '**', component: PageNotFoundComponent, pathMatch: 'full'}
];
// AIzaSyDRT3XwByQN5jwYGz2U-OmwQgNyvxDGLWU
